export function getOrientation() {
  return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
}

// TODO - use Vuetify's useDisplay composable - https://vuetifyjs.com/en/features/display-and-platform/#interface
export function isMobileDevice() {
  return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function isAndroidTablet() {
  return /Tablet/i.test(navigator.userAgent);
}

export function isIpad() {
  return /Ipad/i.test(navigator.userAgent);
}

export function isEdge() {
  return /Edge/i.test(navigator.userAgent);
}
